<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="hxSkuPlatformCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :height="800"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel
          label="SKU"
          labelKey="table_label_hxSkuNo"
          :value="row.hxSkuNo"
          primary
        />
        <TableLabel
          label="SIZE"
          labelKey="table_label_goodsSize"
          :value="row.goodsSize"
        />
        <TableLabel
          label="COLOR"
          labelKey="table_label_goodsColor"
          :value="`${row.goodsColor || ''}${row.goodsColorEn || ''}`"
        />
      </template>
      <template v-slot:displayPlatform="{ row }">
        <TableLabel :value="row.salesTitle" />
        <TableLabel
          label="渠道Item号"
          labelKey="table_label_channelItemNo"
          :value="row.channelItemNo"
          primary
        />
        <TableLabel
          label="渠道条码号"
          labelKey="table_label_channelEanNo"
          :value="row.channelEanNo"
          primary
        />
        <TableLabel
          label="运营人员"
          labelKey="table_label_operateName"
          :value="row.operateName"
        />
      </template>
      <template v-slot:displayMaterial="{ row }">
        <div>{{ row.materialInfo }}</div>
        <div>{{ row.materialInfoEn }}</div>
      </template>
      <template v-slot:displayScm="{ row }">
        <div>{{ row.ncNo }}</div>
        <div>{{ row.scmName }}</div>
      </template>
      <template v-slot:displayBox="{ row }">
        <TableLabel
          label="CTN"
          :value="`${row.ctnLength}x${row.ctnWidth}x${row.ctnHeight}cm`"
        />
        <TableLabel label="N.W" :value="`${row.ctnNetWeight || 0} kg`" />
        <TableLabel label="G.W" :value="`${row.ctnGrossWeight || 0} kg`" />
        <TableLabel label="CBM" :value="`${row.ctnCbm || 0} m³`" />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableLabel from './label.vue'
import { format } from '@/libs/util.number.js'
export default {
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'displayImage']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
